import { Stack, Typography } from '@mui/material'
import { useTexts } from './useTexts'

export function Body() {
  const texts = useTexts()

  return (
    <Stack>
      <Typography>{texts.body.description}</Typography>
    </Stack>
  )
}
